import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { RoleService } from '../../../core/services/role.service';
import { RoleDetailsService } from '../../../core/services/role-details.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { UntypedFormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

import { EnvironmentLoaderService } from 'src/app/core/services/environment-loader.service';
import { SearchCandidateService } from 'src/app/core/services/searchCandService-service';
import { LoggedInUserDetails, LoggedInUserAttribute } from '../../../core/models/config';
import { Location } from '@angular/common';
import { LoggedUserDetailsService } from 'src/app/core/services/logged-user-details.service';

// import * as Keycloak from 'keycloak-js';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  host: {
    '(document:click)': 'onbodyClick($event)',
  },
  standalone: false,
})
export class HeaderComponent {
  // search
  searchResponse: any;
  searchControl = new UntypedFormControl();
  filteredSearch: Observable<any>;
  keyClockUrl: '';

  loginUserName: string = '';
  loggedUserDetailsUrl = environment.loggedUserDetailsUrl;
  dashboardUrl: string = environment.dashboardUrl;
  accountDetails: LoggedInUserDetails = <LoggedInUserDetails>{};
  httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  selectedSearch = 'candidate';
  reqFormControl = new UntypedFormControl('', Validators.pattern('^[a-zA-Z0-9@ .,_-]*$'));
  canFormControl = new UntypedFormControl('', Validators.pattern('^[a-zA-Z0-9@ .,_-]*$'));
  migrationMessage: string;
  marqueeEnabled: any;
  constructor(
    private _eref: ElementRef,
    private httpclient: HttpClient,
    private roleService: RoleService,
    private roleSelectedService: RoleDetailsService,
    private route: Router,
    private _searchCandServ: SearchCandidateService,
    public dialog: MatDialog,
    private envLoaderSerive: EnvironmentLoaderService,
    private router: Router,
    public location1: Location,
    private loggedUser: LoggedUserDetailsService,
  ) {
    this.envLoaderSerive.getEnvData().then((envjson) => {
      //marquee code
      this.marqueeEnabled = envjson['marqueeEnabled'];
      this.migrationMessage = envjson['marqueeMsg'];

      this._searchCandServ.setSchedulerUrl(envjson);
      this.loggedUserDetailsUrl = envjson['LoggedUserDetailsUrl'];
      this.keyClockUrl = envjson['KeyClock'];
      this.loggedUser.getLoggedUserDetails().subscribe((user) => {
        if (user) {
          this.loginUserName = user.empName;
          this.accountDetails.firstName = user.empName;
          this.accountDetails.username = user.empName;
          this.accountDetails.firstName = user.empName;
          this.accountDetails.lastName = user.empName;
          this.accountDetails.email = user.empEmail;
          this.accountDetails.emailVerified = false;
          this.accountDetails.attributes = <LoggedInUserAttribute>{ name: [] };
          this.accountDetails.attributes.name = [];
          this.accountDetails.attributes.upn = [];
          this.accountDetails.attributes.EmpNo = [];
          this.accountDetails.attributes.name.push(user.empName.substring(0, user.empName.indexOf(' ')));
          this.accountDetails.attributes.upn.push(user.empEmail);
          this.accountDetails.attributes.EmpNo.push(user.empNo);
          localStorage.setItem('loggedInUser', JSON.stringify(this.accountDetails));
        } else {
          this.accountDetails.firstName = '';
          this.accountDetails.username = '';
          this.accountDetails.firstName = '';
          this.accountDetails.lastName = '';
          this.accountDetails.email = '';
          this.accountDetails.emailVerified = false;
          this.accountDetails.attributes = <LoggedInUserAttribute>{ name: [] };
          this.accountDetails.attributes.name = [];
          this.accountDetails.attributes.upn = [];
          this.accountDetails.attributes.EmpNo = [];
          localStorage.setItem('loggedInUser', JSON.stringify(this.accountDetails));
        }
      });
    });

    // autocomplete filter
    // this.filteredSearch = this.searchControl.valueChanges.pipe(
    //   startWith(''),
    //   debounceTime(300),
    //   distinctUntilChanged(),
    //   switchMap(Val => {
    //     return this._filterSearchFunc(Val || '');
    //   })
    // )
  } // END CONSTRUCTOR

  keyPressedAlphabets(e) {
    //disabled alphabets keys for  phone number
    const key = document.all ? e.keyCode : e.which;
    return (
      (key > 64 && key < 91) ||
      (key > 96 && key < 123) ||
      key == 8 ||
      key == 32 ||
      (key >= 48 && key <= 57) ||
      key == 45 ||
      key == 46 ||
      key == 64 ||
      key == 43
    );
  }

  showSelect() {
    const temp = localStorage.getItem('roleCode');
    if (temp == 'RECRUITER' || temp == 'HiringManager') {
      return true;
    } else {
      return false;
    }
  }

  openDialogSearch(searchVal, searchSelected) {
    if (searchVal.value.length >= 3 && this.canFormControl.valid && this.reqFormControl.valid) {
      // let searchBody = {
      //   searchText: searchVal.value,
      //   companyHiringTypeId: ["IL Lateral"]
      // }
      if (searchSelected == 'candidate') {
        this._searchCandServ.setSearchKeyword(searchVal.value);
        if (this.location1.path().includes('scheduler/search')) {
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['scheduler/search']));
        } else {
          this.router.navigate(['scheduler/search']);
        }
      } else {
        this._searchCandServ.setSearchKeyword(searchVal.value);
        if (this.location1.path().includes('recruiter/requisition/search')) {
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['recruiter/requisition/search']));
        } else {
          this.router.navigate(['recruiter/requisition/search']);
        }
      }

      // this.router.navigate(['scheduler/search'], {state: {data: searchVal.value}})
      // this._searchCandServ.searchCandidate(searchBody)
      //   .subscribe((searchData) => {

      //     if (searchData) {
      //       this.candidateSearchEmit(searchData);
      //     }

      //   })
    }
  } // end of dialog search

  //Advance search
  advanceSearch(value: boolean) {
    // console.log("!!!set value here",value);

    this._searchCandServ.setActiveAdvanceSearch(value);
  }

  //hide menu on click of body
  onbodyClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) // or some similar check
    {
      document.getElementById('mainNav').classList.add('navHide');
    }
  }
  //show hide menu
  infy_mainHamburger() {
    if (document.getElementById('mainNav').classList.contains('navHide')) {
      document.getElementById('mainNav').classList.remove('navHide');
      document.body.style.overflow = 'auto';
    } else {
      document.getElementById('mainNav').classList.add('navHide');
      document.body.style.overflow = 'hidden';
    }
  }
  logout() {
    const url = encodeURI(location.origin);
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    localStorage.removeItem('roleCode');
    localStorage.removeItem('role');
    localStorage.removeItem('userTabLocation');
    localStorage.removeItem('companyHiringType');
    localStorage.removeItem('navFlag');
    localStorage.removeItem('reqSid');
    window.location.href =
      this.keyClockUrl +
      '/realms/infosys/protocol/openid-connect/logout?post_logout_redirect_uri=' +
      url +
      '&id_token_hint=' +
      localStorage.getItem('idToken');

    // let initOptions = {
    //   url: 'https://identitypoc.infosysapps.com/auth', realm: 'infosys', clientId: 'infyclient'
    // }
    // let keycloak = Keycloak(initOptions);
    // keycloak.logout({redirectUri: "/"});
  }

  backButton() {
    this.roleSelectedService.roleCode.subscribe((role) => {
      console.log(role);
      if (role) {
        this.roleService.getRole().subscribe((roleDetails) => {
          console.log(roleDetails);

          roleDetails.forEach((roleData) => {
            if (roleData.role === role) {
              // console.log(roleData.routes[0].path);
              // this.route.navigate([roleData.routes[0].path])
              if (role === 'DBAD' || role === 'DBAS') {
                if (localStorage.getItem('fresherCompHiringTypeId') == '2') {
                  if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                    this.route.navigate([roleData.routes[1].path]);
                  }
                }
                // Condition can be removed when Bulk Creation is required for all CHT.
                else if (localStorage.getItem('fresherCompHiringTypeId') == '1') {
                  if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                    this.route.navigate([roleData.routes[0].path]);
                  }
                } else {
                  if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                    this.route.navigate([roleData.routes[0].path]);
                  }
                }
              } else if (
                localStorage.getItem('roleCode') === 'OFDA' &&
                localStorage.getItem('fresherCompHiringTypeId') == '2'
              ) {
                window['role'] = roleData.role;
                this.route.navigate(['/offermicro/offer/bulkoffer']);
              } else if (
                localStorage.getItem('roleCode') === 'CnB' &&
                (localStorage.getItem('fresherCompHiringTypeId') == '4' ||
                  localStorage.getItem('fresherCompHiringTypeId') == '9')
              ) {
                window['role'] = roleData.role;
                this.route.navigate(['/offermicro/approval/bpmcnbdashboard']);
              } else if (
                localStorage.getItem('roleCode') === 'Offer_Admin' &&
                localStorage.getItem('fresherCompHiringTypeId') == '1'
              ) {
                window['role'] = roleData.role;
                this.route.navigate(['/offermicro/approval/adminOffer']);
              } else if (
                (localStorage.getItem('roleCode') === 'CnBExecutive' &&
                  localStorage.getItem('fresherCompHiringTypeId') == '11') ||
                (localStorage.getItem('roleCode') === 'CnB' && localStorage.getItem('fresherCompHiringTypeId') == '11')
              ) {
                window['role'] = roleData.role;
                this.route.navigate(['/offermicro/cnbExecutive/cnbeleven']);
              } else if (role == 'SCAD') {
                const scadRoles = roleData.hiringIdPaths.find((rotes) => {
                  return rotes.hiringId == localStorage.getItem('fresherCompHiringTypeId');
                });
                if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                  this.route.navigate([scadRoles.routes[0].path]);
                }
              } else {
                window['role'] = roleData.role;
                if (!localStorage.getItem('navFlag') || localStorage.getItem('navFlag') != 'false') {
                  this.route.navigate([roleData.routes[0].path]);
                }
              }
            }
          });
        });
      }
    });
  }

  // filter search func
  // _filterSearchFunc(value) {

  //   let searchBody = {
  //     searchText: value,
  //     companyHiringTypeId: ["IL Lateral"]
  //   }

  //   return this._searchCandServ.searchCandidate(searchBody)
  //     .pipe(
  //       map(searchData => searchData.filter(dataFil => {
  //         return (dataFil.fullName.toLowerCase().indexOf(value.toLowerCase()) === 0 ||
  //           dataFil.cellPhone.toLowerCase().indexOf(value.toLowerCase()) === 0 ||
  //           dataFil.primaryEmail.toLowerCase().indexOf(value.toLowerCase()) === 0 ||
  //           dataFil.dob.toLowerCase().indexOf(value.toLowerCase()) === 0)
  //       }))
  //     )

  // }

  //candidate Search Emit
  candidateSearchEmit(candSelected) {
    console.log(candSelected);
    if (candSelected) {
      // open dialog
      const dialogRef = this.dialog.open(SearchDialog, {
        height: '500px',
        width: '1200px',
        data: candSelected,
      });
      // close dialog
      dialogRef.afterClosed().subscribe((_result) => {
        console.log('The dialog was closed');
      });
    }
  } // end of cand search
}

// dialog componnet
@Component({
  selector: 'search-candidate-view-dialog',
  templateUrl: 'search-candidate-view-dialog.html',
  standalone: false,
})
export class SearchDialog implements OnInit {
  candidateBasicDetails: any;
  candAndAppIds: any;
  candidatesList: any;
  roleCode: any;
  activityList: any;

  constructor(
    public dialogRef: MatDialogRef<SearchDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _searchCandServ: SearchCandidateService,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    let _applictnID;

    this.roleCode = localStorage.getItem('role').split(' ').join('_');
    // or // this.roleCode = this.roleCode.replace(/\s+/g, '_');

    // get activity list
    if (this.roleCode) {
      console.log('!!!!header called the service', this.activityList);
      this._searchCandServ.getProcessActivities(this.roleCode).subscribe((actvtyProcesData) => {
        this.activityList = actvtyProcesData;
      });
    }

    // to know application id from candidate search API
    if (this.data) {
      console.log('venkat', this.data);

      // cand app id and cand id
      this.candAndAppIds = {
        candIds: [],
        appIds: [],
      };

      this.data.map((elem) => {
        for (const indvCand in elem) {
          if (indvCand === 'candidateId') {
            this.candAndAppIds.candIds.push(elem.candidateId);
          }
          if (indvCand === 'jobApply') {
            for (const candKey in elem[indvCand]) {
              this.candAndAppIds.appIds.push(elem[indvCand][candKey].applicationId);
            }
          }
        }
      });

      console.log('venkat', this.candAndAppIds);

      // call get canidate list by id's
      if (this.candAndAppIds.appIds) {
        this.candidatesList = this._searchCandServ
          .getCandidateListByIds(this.candAndAppIds.appIds)
          .subscribe((candData) => {
            this.candidatesList = candData;
            console.log('venkat', this.candidatesList);
            if (this.candAndAppIds.candIds) {
              this.getCandidateDetails(this.candidatesList[0].applicationId, this.candidatesList[0].candidateId);
            }
          });
      }

      // .... should work .....

      // hard coding
      // this.candidatesList =
      //   [{ "candidateId": 1000000691, "applicationId": 10037, "candidateName": "Divya Rai Chauhan", "firstName": "Divya", "lastName": "Chauhan", "middleName": "Rai", "dateOfBirth": "05-Jan-1992", "emailId": "divya.chauhan@gmail.com", "alternateMailId": null, "primaryContactNo": "1289731289", "alternateContactNo": null, "totalYearsOfExperience": "5", "interviewLocation": null, "exEmployeeNum": "320312", "exInfoscion": "Y", "employeeNo": "320312", "gender": null, "applicationdIds": null, "candidateEducation": [{ "candidateEducationId": 1000110, "candidateId": 1000000691, "yearOfPassing": null, "institute": "VIT", "universityName": "Board Of Intermediate Education", "specializationName": "Accountancy", "highestDegree": null, "percentage": "55", "degreeName": "Adv Cert. in Information Tech", "educationTypeName": "Certificate", "createdOn": "2020-04-18T18:33:42.000+0000", "domainValuesId": null }], "candidateExperience": [{ "candidateExperienceId": 1000255, "candidateId": 1000000691, "organizationName": "Infosys", "designation": "Consultant", "dateOfJoining": "04-Jun-2006", "dateOfLeaving": "2017-08-04T10:36:49.000+0000", "currentEmployer": "Infosys", "technology": null, "noticePeriod": null }], "candidateSkills": [{ "candidateSkillKeyModel": null, "primarySkill": ["MS CRM"], "secondarySkill": null, "readyToReskill": null, "caGroup1": null, "caGroup2": null, "expectedCtc": null, "preferredJobLocation": null, "currentLocation": null, "domain": null, "domesticClient": null }], "sourceName": null, "sourceNames": ["Employee Referral"] }]
    }
  }

  // to get candidate basic details
  getCandidateDetails(applicationId, candidateId) {
    this._searchCandServ.getCandidateBasicDetails(applicationId, candidateId).subscribe((res) => {
      this.candidateBasicDetails = res;
      console.log('venkat', this.candidateBasicDetails);
    });
  }
}
